import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ServiciosService } from '../services/servicios.service';
import { ToastController, AlertController, Platform, LoadingController } from '@ionic/angular';
import { Device } from '@ionic-native/device/ngx';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { environment } from 'src/environments/environment';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-home',
  templateUrl: 'home.page.html',
  styleUrls: ['home.page.scss'],
})
export class HomePage {
  pass:string = '';
  telefono: string = '';
  posicion: any;
  version:string;
  mensaje: any;
  cambioPass:any;
  configuracion:any;
  plataforma: any;
  resetPass:boolean = false;
  vista:any=this;
  loading: any;
  compilacion: string = environment.empresa;
  constructor(private router: Router, 
              private ser: ServiciosService, 
              private toastController: ToastController,
              private alertCtrl: AlertController,
              private dev: Device,
              private nav: InAppBrowser,
              private auth: AuthService,
              private plat: Platform,
              private loadingCtrl: LoadingController,
              ){
      this.version = environment.version_apk;
  }
  ngOnInit(): void {
    //Borramos la cache al entrar

    caches.keys().then(function (keyList) {
      return Promise.all(keyList.map(function (key) {      
        return caches.delete(key);
      }));
    })

  }  
  
  borrarLocalStorage() {
    if (localStorage.getItem('id_plataforma') != null) {
      localStorage.removeItem('id_plataforma');
    }
    if (localStorage.getItem('empresa_cloud') != null) {
      localStorage.removeItem('empresa_cloud');
    }
  }

  ionViewWillEnter() {
    if ((localStorage.getItem('codigo_empresa') != null) && (localStorage.getItem('codigo_empresa') > ' ')) {
      localStorage.removeItem('telefono');
      this.telefono = localStorage.getItem('codigo_empresa');
    } else {
      if(localStorage.getItem('telefono') != null) {
        this.telefono = localStorage.getItem('telefono')
      }else {
        this.telefono = '';
      }
    }
    if (this.auth.isAuthenticated()) {
      this.auth.logout();
    }
  }
  getConfiguracion(){
    this.ser.getConfiguracion('ANDROID').subscribe(async conf=> {
      this.configuracion = conf;   
      if (this.configuracion.version_app != environment.version_apk) {
        this.resetPass;
        this.presentAlert('Existe una nueva versión de la app, pulse Aceptar para actualizar');
      } else {
        await this.presentLoading('Comprobando...');
        this.auth.login(this.telefono, this.pass, this.version, this.vista);
      }
    }, async error => {
      const alert = await this.alertCtrl.create({
        message: 'Error al conectar con el servidor, haga clic en "Aceptar" para recargar.',
        buttons: [
          {
            text: 'Aceptar',
            handler: () => {
              location.reload();
            }
          }
        ]      
      });
    await alert.present();
    });
  }
  introducePass(caracter:String) {
    if(this.telefono.length < 9) {
      this.telefono += caracter;
      if ((localStorage.getItem('codigo_empresa') == null) || (localStorage.getItem('codigo_empresa') <= '')) {
        localStorage.setItem('telefono', this.telefono);
      }else {
        localStorage.setItem('codigo_empresa', this.telefono);
      }
    } else {
      if (this.pass.length < 4) {
        this.pass += caracter;
      }
    }
  }
  borra(){    
    if(this.pass.length > 0) {
      this.pass = this.pass.slice(0,-1);
    }else {
      if(this.telefono.length > 0){
        this.telefono = this.telefono.slice(0,-1);
        if ((localStorage.getItem('codigo_empresa') == null) || (localStorage.getItem('codigo_empresa') <= '')) {
          localStorage.setItem('telefono', this.telefono);
        }else {
          localStorage.setItem('codigo_empresa', this.telefono);
        } 
      }
    } 
  }
  borratodo(){    
    if(this.pass.length > 0) {
      this.pass = '';
    }
    if(this.telefono.length > 0){
      this.telefono = '';
      if ((localStorage.getItem('codigo_empresa') == null) || (localStorage.getItem('codigo_empresa') <= '')) {
        localStorage.setItem('telefono', this.telefono);
      }else {
        localStorage.setItem('codigo_empresa', this.telefono);
      } 
    }
  }
  recuperaPass(){
    this.resetPass = true;
    this.presentAlert('¿Esta solicitando una nueva contraseña, esta seguro?');
  }
  
  setRecuperapassword(){   
    this.ser.setCambiaPassword('', '', '', '', '-1').subscribe((data) => {
      this.cambioPass = data;
      if(this.cambioPass != null) {
        if(this.cambioPass.id == 1) {
          this.pass = '';
          this.presentAlertbasico(this.cambioPass.mensaje);          
          this.ser.setRecuperaPassword(localStorage.getItem('telefono'), this.cambioPass.auxiliar, this.cambioPass.auxiliar2).subscribe((resp)=>{});    
        }
      }
    })    
    this.resetPass = false;
  }
  async confirmar() {
    // Esto es sólo para pruebas nuestras:
    // if ((this.telefono == '663971745') && (this.pass == '0')) {
    //   this.dameEmpleados();
    //   this.presentAlertbasico('Por favor, espere...');
    //   return;
    // }

    if (this.telefono.length < 9) {
      this.presentAlertbasico('Introduzca un teléfono válido');
    }else {
      if (this.pass.length < 4){
        this.presentAlertbasico('Introduzca una contraseña válida');
      }else {
        let plataforma = this.plat.platforms();
        let encontrado = false;
        plataforma.forEach(plat => {
          if (plat.toUpperCase() == 'ANDROID') {
            encontrado = true;
          }
        });
        //Vamos a obligar a que si es una apk compruebe la version y si no actualiza la web     
        
        if (this.plat.is('cordova')) {
          encontrado = true;
        }else {
          encontrado = false;
        }
        
        if(encontrado) {          
          this.getConfiguracion();          
        } else {
          await this.presentLoading('Cargando...');          
          this.auth.login(this.telefono, this.pass,this.version,this.vista);
        }
      }
    }
  }
  async presentToast() {
    const toast = await this.toastController.create({
      message: ' El password introducido es incorrecto ',
      duration: 3000,
      position: 'bottom'
    });
    toast.present();
  }
  async presentAlert(mensaje: string) {
    const alert = await this.alertCtrl.create({
      message: mensaje,
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
          }
        }, {
          text: 'Aceptar',
          handler: () => {
            if(this.resetPass == true) {
              this.setRecuperapassword();   
            } else {             
              this.nav.create(this.configuracion.url_update_app, '_system');              
            }
          }
        }
      ]      
    });
    await alert.present();
  }

  async presentAlertbasico(mensaje: string) {
    const alert = await this.alertCtrl.create({
      message: mensaje,
      buttons: ['OK']
    });
    await alert.present();
  }

  abrirAyuda() {
    this.ser.abrirAyuda();
  }

  async presentLoading(message: string) {
    this.loading = await this.loadingCtrl.create({
      message
      // duration: 2000
    });
    return this.loading.present();
  }

  /**
   * Esta función sólo sirve para hacer pruebas de rendimiento.
   */
  public async dameEmpleados() {
    let tipo = 'E';
    let fechaAUtilizar = new Date();

    let nIteraciones = Array.from({length: 500}, (_, i) => i + 1);

    const empleados: any[] = await this.ser.dameEmpleados().toPromise() as any;

    let enviosBien = 0;
    let enviosMal = 0;
    let totalPeticiones = 0;

    if (empleados && (empleados.length > 0)) {
      for await (const i of nIteraciones) {
        console.log('##### ITERACIÓN Nº ' + i + ' #####');

        for await (let empleado of empleados) {
          console.log('Empleado: ' + empleado.nombre_empleado);

          await this.ser.getLogin(empleado.telefono_marcajes, empleado.password_marcajes, null)
            .toPromise()
            .then(async (mensaje: any) => {
              totalPeticiones++;

              console.log(empleado.nombre_empleado + ' va a iniciar la sesión.');
              localStorage.setItem('id_plataforma', mensaje.id_plataforma);
              localStorage.setItem('empresa_cloud', mensaje.empresa_cloud);
              sessionStorage.setItem('token', mensaje.token);
              localStorage.setItem('telefono', empleado.telefono_marcajes);
    
              console.log(empleado.nombre_empleado + ' va a fichar.');
              const a: any = await this.ser.setInsertaMarcaje({
                cambio_pass_boton: 2,
                cambio_tel_boton: 2,
                codigoMotivo: 1,
                empleado: 3,
                empresa: 0,
                entrada: 1,
                fecha: fechaAUtilizar,
                fecha_boton: 2,
                fecha_time: fechaAUtilizar,
                finalizar_jornada: 0,
                historico_boton: 2,
                hora_boton: 2,
                id: 0,
                mensaje: '',
                motivo: ' ',
                motivos_boton: 2,
                nombreEmpleado: empleado.nombre_empleado,
                refresh_boton: 2,
                salida: 2,
              }, false, 'plataforma_pruebas', tipo, '', '', '', 0).toPromise();

              totalPeticiones++;

              if (a && (a.mensaje == 'OK')) {
                enviosBien++;
              } else {
                enviosMal++;
              }
            });
        }

        if (tipo == 'E') {
          tipo = 'S';
        } else {
          tipo = 'E';
          fechaAUtilizar.setMinutes(fechaAUtilizar.getMinutes() + 1);
        }
      }
    }


    console.log({
      enviosBien,
      enviosMal,
      totalPeticiones
    });

  }
}
